import api from '@pray/shared/utils/api';

export type MarketingCampaignBulkUpdate = {
  field: string;
  operation: string;
  value?: string | number | null;
  values?: string[];
};

export const bulkUpdateMarketingCampaigns = async ({
  artistId,
  campaignIds,
  updates,
}: {
  artistId: string;
  campaignIds: string[];
  updates: MarketingCampaignBulkUpdate[];
}) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/bulk`;
  const response = await api.executePutRequest(url, {
    campaign_ids: campaignIds,
    updates,
  });
  return response.data;
};
